import React from 'react'
import Header from './Header'
import { Outlet } from 'react-router-dom'
import Footer from './Footer'

const Layout = () => {
  return (
    <div>
        <Header/>
        <div style={{padding:"20px"}}>
        <Outlet/>
        </div>
        <Footer/>
    </div>
  )
}

export default Layout